import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';

const T = Translator.create();
let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');
const _logger = Log.create('VirtualClass-Service');

export class VirtualClassService {
    constructor() {
        _apiClient = new ApiClient();
    }

    // Get join virtualClass remoteId
    public async RequestJoinVirtualClassActivityAsync(params: any) {
        if (params.VirtualClassRemoteId !== null) {
            let isError = false;
            let errorList: any;

            return _apiClient
                .RequestAsync('POST', 'api/virtualclass/join', params, token)
                .then((responseData: Response) => {
                    return responseData;
                })
                .then((responseData: Response) => {
                    if (responseData.status !== 200) {
                        isError = true;
                    }
                    return responseData.json();
                })
                .then(response => {
                    if (isError) {
                        errorList = response;
                        errorList
                            ? Object.keys(errorList).forEach((key: any) => {
                                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                            })
                            : Notification.setNotification('error', T.t('r_api_virtual_class_error_virtual_class_remote_id'), 'topRight');
                        
                        return null;
                    } else {
                        return response;
                    }
                })
                .catch(response => {
                    errorList = response;
                        errorList
                            ? Object.keys(errorList).forEach((key: any) => {
                                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                            })
                            : Notification.setNotification('error', T.t('r_api_virtual_class_error_virtual_class_remote_id'), 'topRight');
                    return false;
                });
                // .then((responseData: Response) => {
                //     if (responseData.status !== 200) {
                //         Notification.setNotification('error', T.t('r_api_virtual_class_error_virtual_class_remote_id'), 'topRight');
                //         return null;
                //     } else {
                //         return responseData.json();
                //     }
                // })
                // .then((result: any) => {
                //     return result;
                // })
                // .catch(response => {
                //     return false;
                // });
        }
    }

        // Get join virtualClass remoteId
    public async RequestRecalculateVirtualClassActivityAsync(params: any) {
            if (params.VirtualClassRemoteId !== null) {
                let isError = false;
                let errorList: any;
    
                return _apiClient
                    .RequestAsync('POST', 'api/virtualclass/calculateprogress', params, token)
                    .then((responseData: Response) => {
                        return responseData;
                    })
                    .then((responseData: Response) => {
                        if (responseData.status !== 200) {
                            isError = true;
                        }
                        return responseData.json();
                    })
                    .then(response => {
                        if (isError) {
                            errorList = response;
                            errorList
                                ? Object.keys(errorList).forEach((key: any) => {
                                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                                })
                                : Notification.setNotification('error', T.t('r_api_virtual_class_error_virtual_class_remote_id'), 'topRight');
                            
                            return null;
                        } else {
                            return response;
                        }
                    })
                    .catch(response => {
                        errorList = response;
                            errorList
                                ? Object.keys(errorList).forEach((key: any) => {
                                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                                })
                                : Notification.setNotification('error', T.t('r_api_virtual_class_error_virtual_class_remote_id'), 'topRight');
                        return false;
                    });
                    // .then((responseData: Response) => {
                    //     if (responseData.status !== 200) {
                    //         Notification.setNotification('error', T.t('r_api_virtual_class_error_virtual_class_remote_id'), 'topRight');
                    //         return null;
                    //     } else {
                    //         return responseData.json();
                    //     }
                    // })
                    // .then((result: any) => {
                    //     return result;
                    // })
                    // .catch(response => {
                    //     return false;
                    // });
            }
        }

    // Get Lesson-Page Header Information
    public async RequestAddVirtualClassActivityAsync(params: any) {
        let setUrl = 'api/virtualclass/add';

        if (params.VirtualClassData.activityId) {
            setUrl = 'api/virtualclass/update';
        }

        return _apiClient
            .RequestAsync('POST', setUrl, params.VirtualClassData, token)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestGetVirtualClassAsync(params: any) {
        return _apiClient
            .RequestAsync('POST', 'api/activity/activitylist', params)
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    // Get Assignement Activity Datas
    public async RequestGetUpdateVirtualClassActivity(params: any) {
        return _apiClient
            .RequestAsync('POST', 'api/virtualclass/get', params.updateVirtualClassParams, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    responseData
                        .text()
                        .then(data => {
                            Notification.setNotification('error', T.t(data), 'topRight');
                        })
                        .catch();
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return false;
            });
    }

    // Get Lesson-Page Header Information
    public async RequestDeleteVirtualClassActivityAsync(params: any) {
        return _apiClient
            .RequestAsync('POST', 'api/virtualclass/delete', params.VirtualClassData, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification('error', T.t('r_course_page_lessonHeaderInfo_error_message'), 'topRight');
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                Notification.setNotification('error', T.t('r_course_page_lessonHeaderInfo_error_message'), 'topRight');
                return false;
            });
    }

    public async RequestGetMyAsync(params: any) {
        return _apiClient
            .RequestAsync('GET', 'api/virtualclass/my' + '?Skip=' + params.Skip + '&Take=' + params.Take + '&lastActivityId=' + params.lastActivityId, null, token)
            .then((responseData: Response) => {
                return responseData;
            })
            .catch(responseData => {
                return responseData;
            });
    }
}
